import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Agent, AgentCategoryId } from '../../types/platform';
import { getSolution } from '../../data/solutions';
import { AgentIcon } from '../platform/AgentIcon';
function Field({
  label,
  items
}: {
  label: string;
  items: string[];
}) {
  return <div data-id="element-43" data-mp="jjzpljhfe1x1">
      <dt className="text-[11px] font-semibold uppercase tracking-[0.1em] text-text-tertiary" data-id="element-44" data-mp="jk839dldhb9a">{label}</dt>
      <dd className="mt-1.5" data-id="element-45" data-mp="ygpabsmj43q1">
        <ul className="flex flex-wrap gap-1.5" data-id="element-46" data-mp="tjyzbjpkzybh">
          {items.map(item => <li key={item} className="rounded-md border border-hairline-soft bg-surface px-2 py-0.5 text-[13px] text-text-secondary" data-id="element-47" data-mp="17b3zcmwv2smc">
              {item}
            </li>)}
        </ul>
      </dd>
    </div>;
}
export function AgentCard({
  agent,
  category
}: {
  agent: Agent;
  category: AgentCategoryId;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-hairline bg-panel p-5 transition-[border-color,box-shadow] duration-200 hover:border-[#D8D4EA] hover:shadow-md" data-id="element-48" data-mp="1cazsfr40szn4">
      <div className="flex items-start gap-3" data-id="element-49" data-mp="12m5v4414s0eb">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-violet-soft text-lime" data-id="element-50" data-mp="12mxrhh2jy25n">
          <AgentIcon category={category} className="h-5 w-5" data-id="element-51" data-mp="17nlii2qs6izv" />
        </span>
        <div className="min-w-0" data-id="element-52" data-mp="1bonk2q867750">
          <h3 className="text-base font-semibold leading-snug tracking-[-0.01em] text-text-primary" data-id="element-53" data-mp="1bkreg1effjg5">{agent.name}</h3>
          <p className="mt-1 text-sm leading-relaxed text-text-secondary" data-id="element-54" data-mp="1ll0ejqbjhp0t">{agent.purpose}</p>
        </div>
      </div>
      <dl className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-55" data-mp="1qbqg0sguh7q8">
        <Field label="Inputs" items={agent.inputs} data-id="element-56" data-mp="1qe365swraoed" />
        <Field label="Outputs" items={agent.outputs} data-id="element-57" data-mp="1va1pv3753i8g" />
        <div className="sm:col-span-2" data-id="element-58" data-mp="1vcwez813lr87">
          <Field label="Example use cases" items={agent.useCases} data-id="element-59" data-mp="1zdpzrsj8upwv" />
        </div>
      </dl>
      <div className="mt-auto border-t border-hairline-soft pt-4" data-id="element-60" data-mp="24azyjysiwdxd">
        <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-text-tertiary" data-id="element-61" data-mp="49i7omi00gnt">Compatible workflows</p>
        <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-62" data-mp="8gh0u25dcxg">
          {agent.workflows.map(id => {
          const solution = getSolution(id);
          if (!solution) return null;
          return <li key={id} data-id="element-63" data-mp="9837wlx930c9">
                <Link to={`/solutions#${id}`} className="inline-flex min-h-[32px] items-center gap-1 rounded-md bg-lime/5 px-2 text-xs font-semibold uppercase tracking-[0.06em] text-lime hover:bg-violet-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-64" data-mp="97tip0k14x7m">
                  {solution.label}
                  <ArrowRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-65" data-mp="rykvkc3875qr" />
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </article>;
}